import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import IconButton from '@/app/components/button/IconButton.vue'

import { DocView } from '@/models/doc'


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportBookButton',
  props: {
    doc: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IconButton, {
    tag: "router-link",
    icon: "idownload",
    tooltip: "Download & Export",
    outlined: "",
    to: {
      name: __props.doc.routeNames().export,
      params: { url_slug: __props.doc.url_slug },
    }
  }, null, 8, ["to"]))
}
}

})